import { UIText3 } from '@cian/ui-kit';
import { Attention16 } from '@cian/ui-kit/prev';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './Pessimization.css';
import { EPessimizationBackground, IPessimization } from '../../types';

interface IPessimizationProps {
  pessimization: IPessimization;
}

export const Pessimization: React.FC<React.PropsWithChildren<IPessimizationProps>> = ({
  pessimization: { background, text },
  children,
}) => {
  return (
    <div className={styles['container']}>
      {children}
      <div
        className={classNames(styles['banner'], {
          [styles['banner--red']]: background === EPessimizationBackground.Red,
        })}
      >
        <Attention16 display="block" color="white_100" />
        <UIText3 as="p" color="white_100" textAlign="center">
          {text}
        </UIText3>
      </div>
    </div>
  );
};
